// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4221":"c6c2f59e","5971":"a84cf73e","7684":"3ca52bbf","7850":"e04d476d"}[chunkId] + ".chunk.css";
};